import Vue from 'vue'
import AjaxCart from '../helpers/AjaxCart'
import Helpers from '../helpers/Helpers'
import AjaxAPI from '../helpers/AjaxAPI'

class Cart {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = document.querySelector('section.cart')
        this.vue = null
    }
    async onInit () {
        const _cart = await AjaxCart.getCart()
        console.log(_cart.data)
        this.vue = new Vue({
            el: 'section.cart',
            data: {
                cart: _cart.data || null,
                needsUpdate: false,
                theme: this.theme,
                cartCount: document.querySelector('.user-menu__item--bag')
            },
            mounted: async function () {
                document.addEventListener('cartItemAdded', () => {
                    this.updateCart()
                })
                this.updateCart()
            },
            filters: {
                money: (n) => {
                    return Helpers.formatMoney(n)
                },
                pluralize: (count, single, multiple) => {
                    if (count > 1) {
                        return count + multiple
                    } else {
                        return count + single
                    }
                }
            },
            methods: {
                updateCart: async function () {
                    let payload = {}
                    this.needsUpdate = false
                    let current = await AjaxCart.getCart()
                    for (let item of current.data.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                    document.querySelectorAll('.cart__quantity-change').forEach(button => {
                        button.classList.remove('disabled')
                    })
                    if (this.cart.item_count > 0) {
                        this.cartCount.classList.add('items-in-cart')
                        this.cartCount.querySelector('span').textContent = this.cart.item_count
                    } else {
                        this.cartCount.classList.remove('items-in-cart')
                        this.cartCount.querySelector('span').textContent = ''
                    }
                    this.theme.registerComponents(this.$el)
                },
                getPrice: async function (handle, id, index, qty) {
                    const response = await AjaxAPI.getProduct(handle)
                    const prodData = response.data
                    let innerLine = ''
                    let innerTotal = ''
                    let sale = false
                    let classToUse = ''
                    prodData.variants.forEach(variant => {
                        if (variant.id === id) {
                            if (variant.price < variant.compare_at_price) {
                                const comp = Helpers.formatMoney(variant.compare_at_price)
                                const compTotal = Helpers.formatMoney(variant.compare_at_price * qty)
                                innerLine += '<p class="product-price--original">' + comp + '</p>'
                                innerTotal += '<p class="product-price--original">' + compTotal + '</p>'
                                sale = true
                            }
                            if (sale) {
                                classToUse = 'product-price--sale'
                            } else {
                                classToUse = ''
                            }
                            const price = Helpers.formatMoney(variant.price)
                            const priceTotal = Helpers.formatMoney(variant.price * qty)
                            innerLine += '<p class="' + classToUse + '">' + price + '</p>'
                            innerTotal += '<p class="' + classToUse + '">' + priceTotal + '</p>'
                        }
                    })
                    const dump = document.createElement('div')
                    const dump2 = document.createElement('div')
                    dump.innerHTML = innerLine
                    dump2.innerHTML = innerTotal
                    const prices = document.querySelectorAll('.cart__item-price')
                    const totals = document.querySelectorAll('.cart__item-final-price')
                    prices[index].innerHTML = dump.innerHTML
                    totals[index].innerHTML = dump2.innerHTML
                },
                removeItem: async function (item) {
                    item.quantity = 0
                    item.removed = true
                    await AjaxCart.removeItem(item.id)
                    this.updateCart()
                },
                handleChange: async function (item, i) {
                    document.querySelectorAll('.cart__quantity-change').forEach(button => {
                        button.classList.add('disabled')
                    })
                    this.needsUpdate = true
                    let id = item.variant_id
                    let quantity = item.quantity + i
                    let payload = '{' + id + ': ' + quantity + '}'
                    item.quantity = quantity
                    await AjaxCart.updateItems(payload)
                    payload = {}
                    this.needsUpdate = false
                    for (let item of this.cart.items) {
                        payload[item.key] = item.quantity
                    }
                    if (payload) {
                        const _cart = await AjaxCart.updateItems(payload)
                        if (_cart.status === 200) {
                            this.cart = _cart.data
                        }
                    }
                    this.updateCart()
                },
                itemImage: function (src) {
                    return Helpers.getSizedImageUrl(src, '79x114')
                },
                toggleClass: function (elem, classToAdd) {
                    console.log(elem)
                    document.querySelector(elem).classList.toggle(classToAdd)
                }
            }
        })
        window.vueJob = this.vue
    }
}

export default Cart



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Cart.js